import { memo } from 'react';
import { IVizChartProps } from './viz-chart.interfaces';
import { LegacyVizChartUnMemoized } from './viz-chart.component';

export const LegacyVizChart = memo<IVizChartProps>(LegacyVizChartUnMemoized);
